import { render, staticRenderFns } from "./CcSecondaryFilter.ts.vue?vue&type=template&id=dc48ae88"
import script from "./CcSecondaryFilter.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./CcSecondaryFilter.ts.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports